import React, { useEffect, useState } from "react";
import { useTypedSelector } from "../../store";
import {  SearchOutlined } from "@ant-design/icons";
import {
  Button,
  Empty,
  Input,
  Modal,
  Skeleton,
  Space,
  Table,
} from "antd";
import { ColumnsType } from "antd/es/table";
import { useDispatch } from "react-redux";
import { confirmListProfileUpdatesStore, getListProfileUpdatesStore, resetStatusUpdate } from "../../slices/profileUpdate";


interface DataType {
  _id: string;
  employeeId: string;
  name: string;
  person: any;
  contact: any;
  job: any;
}
const ProfileUpdate = () => {
  const dispatch = useDispatch();
  const data = useTypedSelector(state => state.Profile.profileUpdate)
  const update = useTypedSelector(state => state.Profile.confirmUpdate)
  const isPersonUpdate = useTypedSelector(state => state.Profile.personUpdate)
  const isContactUpdate = useTypedSelector(state => state.Profile.contactUpdate)
  const loading = useTypedSelector(state => state.Profile.pageIsLoading)
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState(data);
  const [selectedData, setSelectedData] = useState<any>(null);

  useEffect(() => {
    dispatch(getListProfileUpdatesStore() as any)
  }, [])

  useEffect(() => {
    dispatch(getListProfileUpdatesStore() as any)
  }, [update])

  useEffect(() => {
    if (data) {
      setFilteredData(data)
    }
  }, [data])

  console.log("Data", data);
  console.log("FDDD", filteredData);
  console.log("SDDD", selectedData);
  console.log("P", isPersonUpdate);
  console.log("C", isContactUpdate);

  const handleSearchText = (value: string) => {
    setSearchText(value);
    const filtered = data.filter(
      (data) =>
        data.name.toLowerCase().includes(value.toLowerCase()) ||
        data.employeeId.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredData(filtered);
  };

  const itemSelected = (id: string) => {
    const item = filteredData.find((item: any) => item.employeeId === id)
    setSelectedData(item)
  }

  const columns: ColumnsType<DataType> = [
    {
      title: "Employee ID",
      dataIndex: "employeeId",
      key: "employeeId",
      sorter: (a: any, b: any) =>
        (a.employeeId || "").localeCompare(b.employeeId || ""),
      // render: (text: any) => text || "--",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a: any, b: any) =>
        (a.name || "").localeCompare(b.name || ""),
      // render: (text: any) => text || "--",
    },
    {
      title: "Person Update",
      dataIndex: "person",
      key: "person",
      // sorter: (a: any, b: any) =>
      //     (a.name || "").localeCompare(b.name || ""),
      render: (text: any, record: any) => (
        text !== null ? (

          <p style={{ color: "green" }}>Waiting to review and update...</p>
        ) : (
          <p style={{ color: "grey" }}>no update...</p>
        )
      ),
    },
    {
      title: "Contact Update",
      dataIndex: "contact",
      key: "contact",
      // sorter: (a: any, b: any) =>
      //     (a.name || "").localeCompare(b.name || ""),
      render: (text: any, record: any) => (
        text !== null ? (

          <p style={{ color: "green" }}>Waiting to review and update...</p>
        ) : (
          <p style={{ color: "grey" }}>no update...</p>
        )
      ),
    },
    {
      title: "Job Update",
      dataIndex: "job",
      key: "job",
      // sorter: (a: any, b: any) =>
      //     (a.name || "").localeCompare(b.name || ""),
      render: (text: any, record: any) => (
        text !== null ? (

          <p style={{ color: "green" }}>Waiting to review and update...</p>
        ) : (
          <p style={{ color: "grey" }}>no update!</p>
        )
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_: any, record: any) => (
        <Button
          type="primary"
          style={{ backgroundColor: "#faad14", borderColor: "#faad14" }}
          onClick={() => itemSelected(record.employeeId)}
        >
          View & Update
        </Button>
      ),
    },
  ]
  return (
    <div>
      <Space
        style={{
          marginBottom: 16,
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Space>
          <Input
            placeholder="Search by name or EID"
            value={searchText}
            onChange={(e) => handleSearchText(e.target.value)}
            prefix={<SearchOutlined />}
            style={{ maxWidth: 300 }}
          />

        </Space>

      </Space>
      {!loading ? (
        <Table
          columns={columns}
          dataSource={filteredData}
          scroll={{ x: "max-content" }}
        />
      ) : (
        <Skeleton active />
      )}
      <Modal open={selectedData !== null} okText="Edit" cancelText="Batal" onCancel={() => {setSelectedData(null); dispatch(resetStatusUpdate())}} footer={null}>
        <div>
          <div>
            <h3 style={{ color: "grey" }}>Person</h3>
            {selectedData && selectedData.person ?
              <div style={{ padding: 12, border: '2px solid grey', borderRadius: 8, marginBottom: 35 }}>
                <div style={{ flexDirection: "row", display: "flex", }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>Name</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.person.fullname || ""}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>Place Of Birth</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.person.place_of_birth || ""}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>Date Of Birth</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.person.date_of_birth || ""}</p>
                </div>

                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>Gender</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.person.gender || ""}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>Martial Status</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.person.marital_status || ""}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>Mother Name</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.person.mother_name || ""}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>NPWP</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.person.npwp_number || ""}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>Status TAX</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.person.status_tax || ""}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>ID Number</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.person.number_id || ""}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>Religion</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.person.religion || ""}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex", marginTop: 20, marginBottom: 10 }}>
                  <div style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}></div>
                  <div style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}></div>
                  <div style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>
                    <Button disabled={isPersonUpdate} style={{ marginRight: 10, backgroundColor: "#faad14", borderColor: "#faad14" }}><p style={{ color: "white" }} onClick={() => {dispatch(confirmListProfileUpdatesStore({updateId: selectedData.personId, status: "REJECTED"}) as any)}}>Reject</p></Button>
                    <Button disabled={isPersonUpdate} type="primary" onClick={() => {dispatch(confirmListProfileUpdatesStore({updateId: selectedData.personId, status: "APPROVED"}) as any)}}>Approve</Button>
                  </div>
                </div>
              </div> :
              <div><Empty description="no data to persons update" /></div>}
          </div>
          <div>
            <h3 style={{ color: "grey" }}>Contact</h3>
            {selectedData && selectedData.contact ? <div style={{ padding: 12, border: '2px solid grey', borderRadius: 8, marginBottom: 35 }}>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold",  margin: 0 }}>Phone</p>
                  <p style={{ width: "5%", fontWeight: "bold",  margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold",  margin: 0 }}>{selectedData.contact.phone || "-"}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", margin: 0 }}>Email</p>
                  <p style={{ width: "5%", fontWeight: "bold", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", margin: 0 }}>{selectedData.contact.email || "-"}</p>
                </div>
                <h4>Emergency Contact 1</h4>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>name</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.contact.emergency_contact.name || "-"}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>phone</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.contact.emergency_contact.phone || "-"}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>Status</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.contact.emergency_contact.status || "-"}</p>
                </div>
                 
                <h4>Emergency Contact 2</h4>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>name</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.contact.emergency_contact_second.name || "-"}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>phone</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.contact.emergency_contact_second.phone || "-"}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>Status</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.contact.emergency_contact_second.status || "-"}</p>
                </div>
                
              <h4>Address ID</h4>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>Street</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.contact.address_id.street || "-"}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>Local Unit / RT-RW</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.contact.address_id.local_unit || "-"}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>Sub District / Kelurahan</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.contact.address_id.sub_district || "-"}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>District / Kecamatan</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.contact.address_id.local_unit || "-"}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>City</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.contact.address_id.city || "-"}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>Province</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.contact.address_id.province || "-"}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex", }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>Country</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.contact.address_id.country || "-"}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>Postal Code</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.contact.address_id.postal_code || "-"}</p>
                </div>
                <h4>Domicile</h4>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>Street</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.contact.address_domicile.street || "-"}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>Local Unit / RT-RW</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.contact.address_domicile.local_unit || "-"}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>Sub District / Kelurahan</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.contact.address_domicile.sub_district || "-"}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>District / Kecamatan</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.contact.address_domicile.local_unit || "-"}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>City</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.contact.address_domicile.city || "-"}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>Province</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.contact.address_domicile.province || "-"}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex", }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>Country</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.contact.address_domicile.country || "-"}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  <p style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}>Postal Code</p>
                  <p style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}>:</p>
                  <p style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>{selectedData.contact.address_domicile.postal_code || "-"}</p>
                </div>
                <div style={{ flexDirection: "row", display: "flex", marginTop: 20, marginBottom: 10 }}>
                  <div style={{ width: "45%", fontWeight: "bold", color: "grey", margin: 0 }}></div>
                  <div style={{ width: "5%", fontWeight: "bold", color: "grey", margin: 0 }}></div>
                  <div style={{ width: "50%", fontWeight: "bold", color: "grey", margin: 0 }}>
                    <Button disabled={isContactUpdate} style={{ marginRight: 10, backgroundColor: "#faad14", borderColor: "#faad14" }}><p style={{ color: "white" }} onClick={() => {dispatch(confirmListProfileUpdatesStore({updateId: selectedData.contactId, status: "REJECTED"}) as any)}}>Reject</p></Button>
                    <Button disabled={isContactUpdate} type="primary" onClick={() => {dispatch(confirmListProfileUpdatesStore({updateId: selectedData.contactId, status: "APPROVED"}) as any)}}>Approve</Button>
                  </div>
                </div>
              </div> : <div><Empty description="no data to contacts update" /></div>}
          </div>
          <div>
            <h3 style={{ color: "grey" }}>Job</h3>
            {selectedData && selectedData.job ? <div style={{ padding: 12, border: '2px solid grey', borderRadius: 8, marginBottom: 35 }}>test</div> : <div><Empty description="no data to jobs update" /></div>}
          </div>
        </div>
      </Modal>
    </div>
  )
}
export default ProfileUpdate